@if (options.head || options.resultslimited) {
  <div class="table-header-container">
    @if (options.head) {
      <div class="table-head">
        <div class="view-selector">
          <button [class.selected]="view === 'list'" (click)="setView('list')" tooltip="TOOLTIP.TABLE.LIST_VIEW">
            <mat-icon>view_list</mat-icon>
          </button>
          @if (options.tile) {
            <button [class.selected]="view === 'tile'" (click)="setView('tile')" tooltip="TOOLTIP.TABLE.TILE_VIEW">
              <mat-icon>grid_view</mat-icon>
            </button>
          }
          @if (options.map) {
            <button [class.selected]="view === 'map'" (click)="setView('map')" tooltip="TOOLTIP.TABLE.MAP_VIEW">
              <mat-icon>map</mat-icon>
            </button>
          }
        </div>
        <div class="search-terms">
          <form>
            @for (key of searchkeys; track $index) {
              <mat-chip-row (removed)="removeSearchkey(key)">
                {{ key }}
                <button matChipRemove [attr.aria-label]="'remove ' + key">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
          </form>
        </div>

        <div class="table-addons">
          <ul>
            @if (options.search) {
              <li class="searchContainer">
                <form (keydown)="searchShortcuts($event.code)">
                  <app-prefix-oms (controlchanged)="searchControl = $event" [counter]="false" [label]="'TABLE.SEARCHBAR' | translate" />
                </form>
                <button type="button" (click)="setSearchkeys()" [tooltip]="'TOOLTIP.TABLE.SEARCH'">
                  <mat-icon>search</mat-icon>
                </button>
                <button type="button" (click)="addSearchkeys()" [tooltip]="'TOOLTIP.TABLE.ADD_SEARCH'">
                  <mat-icon>zoom_in</mat-icon>
                </button>
              </li>
            }
            @if (options.filter) {
              <li class="action" [ngClass]="{ filterHighlight: filtersActive }">
                <button type="button" (click)="openFilterDialog()" [tooltip]="'TOOLTIP.TABLE.SHOW_FILTERS'">
                  <mat-icon>{{ "filter_alt" }}</mat-icon>
                </button>
              </li>
            }
            @if (options.filter || options.search) {
              <li class="action">
                <button type="button" [tooltip]="'TOOLTIP.TABLE.CLEAR'" (click)="onClear()">
                  <mat-icon>cancel</mat-icon>
                </button>
              </li>
            }
          </ul>
        </div>
      </div>
    }
    @if (options.resultslimited && options.resultslimitedmaxreached) {
      <div class="resultslimited">{{ "TABLE.LIMITEDRESULTS_MESSAGE" | translate }}</div>
    }
  </div>
}

@if (root) {
  @switch (view) {
    @case ("list") {
      <app-table-list-view
        [root]="root"
        [headers]="headers"
        [options]="options"
        (rowSelection)="onRowSelection()"
        (prefixEvent)="onPrefixEvent($event)"
        (sort)="onSort($event)"
      />
    }
    @case ("tile") {
      <app-table-tile-view
        [root]="root"
        [headers]="headers"
        [options]="options"
        (rowSelection)="onRowSelection()"
        (prefixEvent)="onPrefixEvent($event)"
        (sort)="onSort($event)"
      />
    }
    @case ("map") {
      <app-table-map-view
        [root]="root"
        [headers]="headers"
        [options]="options"
        (rowSelection)="onRowSelection()"
        (prefixEvent)="onPrefixEvent($event)"
        (sort)="onSort($event)"
      />
    }
    @default {
      <span>Table view of type '{{ view }}' is not implemented</span>
    }
  }

  @if ((root | tableGroupAmount).visible < 1) {
    <span class="no-rows">{{ "TABLE.NO_ROWS" | translate }}</span>
  }
}

@if (options.foot || buttons.length) {
  <div class="table-footer-container">
    <div class="table-foot">
      <div class="buttonContainer">
        <app-buttons [buttons]="buttons" (event)="onEvent($event)" (deleteSelectedRows)="deleteRows()" [rowsSelected]="selectedRows.length" />
      </div>

      @if (root) {
        @let amount = root | tableGroupAmount;
        @let start = amount.visible === 0 ? 0 : options.pageSize * (page - 1) + 1;
        @let end = start - 1 + options.pageSize > amount.visible ? amount.visible : start - 1 + options.pageSize;
        <div class="paginator">
          <button [disabled]="page <= 1" (click)="paginate(page - 1)">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <span>{{ start }} - {{ end }} of {{ amount.visible }}</span>
          <button [disabled]="end === amount.visible" (click)="paginate(page + 1)">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      }
    </div>
  </div>
}
